import * as React from 'react'
import { ThemeProvider, createTheme } from '@mui/material'
import Login from 'Pages/Auth/Login'
import Register from 'Pages/Auth/Register'
import RegisterGuest from 'Pages/Auth/RegisterGuest'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import SSOCallback from 'Pages/Auth/SSOCallback'
import Profile from 'Pages/Profile'
import SSOLogin from 'Pages/Auth/SSOLogin'
import Events from 'Pages/Events'
import Notifications from 'Pages/Notifications'
import Settings from 'Pages/Settings'
import ProtectedRoute from 'Components/ProtectedRoute'
import PublicRoute from 'Components/PublicRoute'
import Dashboard from 'Pages/Dashboard'
import LandingPage from 'Pages/LandingPage/LandingPage'
import 'Store/storeSubscriptions'
import * as _ from 'lodash'
import mainTheme from 'Settings/themes/mainTheme'

export default function App() {
      return (
            <ThemeProvider theme={mainTheme}>
                  <Router>
                        <Routes>
                              <Route path="/" element={<LandingPage />} />
                              {/* Public Routes */}
                              <Route element={<PublicRoute />}>
                                    <Route path=":id?" element={<RegisterGuest />} />
                                    {/* <Route path=":id?/signin" element={<Login/>} /> */}
                                    <Route path=":id?/signup" element={<Register />} />
                                    <Route path=":id?/signin" element={<RegisterGuest />} />

                                    <Route
                                          path=":id?/sign-up/sso-callback"
                                          element={<SSOCallback />}
                                    />
                                    <Route path=":id?/sign-in/sso-login" element={<SSOLogin />} />
                              </Route>

                              {/* Protected Routes */}
                              <Route element={<ProtectedRoute />}>
                                    <Route path="dashboard" element={<Dashboard />} />
                                    <Route path="profile" element={<Profile />} />
                                    <Route path="events" element={<Events />} />
                                    <Route path="settings" element={<Settings />} />
                                    <Route path="notifications" element={<Notifications />} />
                              </Route>
                        </Routes>
                  </Router>
            </ThemeProvider>
      )
}
